var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"marker",style:({
    top: (_vm.markerTop + "px"),
    left: (_vm.markerLeft + "px"),
    width: (_vm.boxWidth + "px"),
    height: (_vm.boxHeight + "px"),
  })},[_c('div',{staticClass:"hint"},[_vm._v(_vm._s(_vm.hint))]),_c('svg',{staticClass:"marker-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","fill":"currentColor"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z","clip-rule":"evenodd"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }